export const initialiseMetrics = (key: string, _host: string) => {
    // if any metrics require initialisation, do it here.

    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${key}`;
    document.head.appendChild(gtagScript); 
    
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${key}');
    `;
    document.head.appendChild(inlineScript);

};